import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=026a7a08&scoped=true&"
import script from "./Error.vue?vue&type=script&lang=ts&"
export * from "./Error.vue?vue&type=script&lang=ts&"
import style0 from "./Error.vue?vue&type=style&index=0&id=026a7a08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026a7a08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('026a7a08')) {
      api.createRecord('026a7a08', component.options)
    } else {
      api.reload('026a7a08', component.options)
    }
    module.hot.accept("./Error.vue?vue&type=template&id=026a7a08&scoped=true&", function () {
      api.rerender('026a7a08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Error.vue"
export default component.exports